import { EngineIcon } from '@phosphor-icons/react';

import styles from './legend-symbols.module.scss';

export type LegendSymbolProps = {
  /** Edge length in px. Defaults to the legend's own size; ticket 08's cluster markers pass theirs. */
  size?: number;
};

/**
 * The Field Area treatment, as a symbol: the accent swatch the Boundary overlays are tinted from
 * (113584 §13a — a legend swatch matches the colour used for that element on the map).
 *
 * Lives apart from `<MapLegend>` because it has a second consumer: a **field** cluster marker
 * carries this symbol so a group of Fields never reads as a group of Devices (113586 §14b,
 * ticket 08).
 */
export function FieldAreaSymbol({ size = 12 }: LegendSymbolProps) {
  return <span className={styles.fieldArea} style={{ width: size, height: size }} aria-hidden />;
}

/**
 * The Device treatment, as a symbol: the same Engine glyph in the same red the map's Device pins
 * use. Second consumer as above — a Device cluster marker (113586 §14b, ticket 08).
 */
export function DeviceSymbol({ size = 16 }: LegendSymbolProps) {
  return <EngineIcon size={size} weight="fill" className={styles.device} aria-hidden />;
}
